import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { McpToolName } from '@systemeio/ai-chat-types';
import { AiChatWidgetHost, AiChatWidgetHostProps } from '@systemeio/ai-chat-widget';
import { useRevalidateModules } from '@systemeio/util';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { pageRoute } from 'shared/constants/routes.constants';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import useUser from 'shared/hooks/use-user';
import { getPageRoute } from 'shared/utils/get-dynamic-page-route';
export const AiChatTriggerButton = () => {
  const $ = _c(4);
  const {
    user
  } = useUser();
  const aiChatFeatureIsOn = useFeatureIsOn(GrowthbookFlagsEnum.AiChat);
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] !== revalidateModules) {
    t0 = toolCall => {
      if (toolCall.output.isError) {
        return;
      }
      bb5: switch (toolCall.toolName) {
        case McpToolName.AssignContactTag:
        case McpToolName.RemoveContactTag:
        case McpToolName.CreateContact:
        case McpToolName.RemoveContact:
        case McpToolName.UpdateContact:
          {
            revalidateModules([RequestModuleEnum.Contacts], true);
            break bb5;
          }
        case McpToolName.CreateTag:
        case McpToolName.RemoveTag:
        case McpToolName.UpdateTag:
          {
            revalidateModules([RequestModuleEnum.Tags], true);
            break bb5;
          }
        case McpToolName.CreateNewsletter:
        case McpToolName.UpdateNewsletter:
        case McpToolName.SetNewsletterIncludedTags:
        case McpToolName.SetNewsletterExcludedTags:
          {
            revalidateModules([RequestModuleEnum.Newsletters], true);
            break bb5;
          }
        case McpToolName.CreateCampaign:
        case McpToolName.UpdateCampaign:
          {
            revalidateModules([RequestModuleEnum.Campaign], true);
            break bb5;
          }
        case McpToolName.DeleteCampaign:
          {
            revalidateModules([RequestModuleEnum.Campaign, RequestModuleEnum.CampaignStep], true);
            break bb5;
          }
        case McpToolName.CreateCampaignStep:
        case McpToolName.UpdateCampaignStep:
        case McpToolName.DeleteCampaignStep:
          {
            revalidateModules([RequestModuleEnum.CampaignStep], true);
            break bb5;
          }
        case McpToolName.CreateAutomationRule:
        case McpToolName.UpdateAutomationRule:
        case McpToolName.DeleteAutomationRule:
          {
            revalidateModules([RequestModuleEnum.AutomationRule], true);
            break bb5;
          }
        case McpToolName.CreateCoupon:
        case McpToolName.UpdateCoupon:
        case McpToolName.DeleteCoupon:
          {
            revalidateModules([RequestModuleEnum.Coupons], true);
            break bb5;
          }
        case McpToolName.CreatePricePlan:
        case McpToolName.UpdatePricePlan:
        case McpToolName.DeletePricePlan:
          {
            revalidateModules([RequestModuleEnum.PricePlans], true);
            break bb5;
          }
        case McpToolName.CreateDigitalProduct:
        case McpToolName.UpdateDigitalProduct:
        case McpToolName.DeleteDigitalProduct:
          {
            revalidateModules([RequestModuleEnum.DigitalProducts], true);
            break bb5;
          }
        case McpToolName.CreateFunnel:
          {
            revalidateModules([RequestModuleEnum.Funnels], true);
            break bb5;
          }
        case McpToolName.CreateFunnelStep:
        case McpToolName.SaveContent:
        case McpToolName.SaveFunnelPageContent:
          {
            revalidateModules([RequestModuleEnum.FunnelsStep], true);
            break bb5;
          }
        default:
      }
    };
    $[0] = revalidateModules;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleToolCallOutput = t0;
  if (!aiChatFeatureIsOn || !user) {
    return null;
  }
  let t1;
  if ($[2] !== handleToolCallOutput) {
    t1 = <div className="ai-chat-widget" data-test-id="ai-chat-button"><AiChatWidgetHost UpgradeLink={_temp} onToolCallOutput={handleToolCallOutput} /></div>;
    $[2] = handleToolCallOutput;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(props) {
  return <LinkWithoutPrefetch href={getPageRoute(pageRoute.ProfileUserPlan)} {...props} />;
}